import styled from 'styled-components';

export const ModalTitle = styled.h2`
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  color: #858dbd;
  margin: 0;
  text-align: center;
`;
